import React from 'react'
import { Provider, useSelector } from 'react-redux'
import store from './store'
import AESForm from './formSections'
import EUHeader from '../../header'
import AcknowledgementPageAES from './formSections/acknowledgementPageAES'
import AesEuHeader from './aesEUHeader';

function AESApp(props) {
  return (
    <Provider store={store}>
      <AesEuHeader
      shipmentId={props?.shipId}
      renderEuHeader={(extraProps) =><EUHeader
        translate={props.translate}
        shipId={props.shipId}
        EUData={props.EUData}
        setEUData={props.setEUData}
        shipmentCountry={props.countryCode}
        kxUser={props.kxUser}
        {...props.headerProps}
        version={props.version}
        {...extraProps}
        kxEngineUserInfo={props?.kxEngineUserInfo}
      />}
      />
      {props.finalReview ? (
        <AcknowledgementPageAES
          euPdf={props.euPdf}
          key='finalReview'
          handleLegalAcknowledgement={props.handleLegalAcknowledgement}
          loadShipment={props.loadShipment}
          translate={props.translate}
          countryCheck={props.currentJobData?.countryCode}
          version={props.version}
        />
      ) : (
        <AESForm {...props} kxEngineUserInfo={props?.kxEngineUserInfo} />
      )}
    </Provider>
  )
}

export default React.memo(AESApp)
